import React, { useEffect } from 'react';
import './home.css';
import Navbar from "../../components/Navbar/Navbar";
import HomeProjects from '../projects/HomeProjects';
import Footer from '../footer/Footer';
import i18n from '../../i18n';


export default function Home() {
  
  
  
  useEffect(() => {
    const savedLanguage = localStorage.getItem('language') || 'en';
    i18n.changeLanguage(savedLanguage);

    const rootElement = document.getElementById('root');
    if (savedLanguage === 'fa' || savedLanguage === 'ar') {
      rootElement.classList.remove('ltr', 'text-left');
      rootElement.classList.add('rtl', 'text-right');
    } else {
      rootElement.classList.remove('rtl', 'text-right');
      rootElement.classList.add('ltr', 'text-left');
    }
  }, []);
  

  return (
    <>
      <div className="min-h-screen ltr w-[100%]   desktopXL:h-full flex flex-col bgColor  items-center">
      
      {/* Navbar & logo */}
      <header className="sticky top-0 z-50 flex items-center justify-center w-full">
        <div className="m-auto p-3 w-[100%] ltr">
          <Navbar />
        </div>
      </header>

      <div className='flex flex-col justify-center items-center w-[100%] desktop:w-[75%]  '>
 
        {/* Projects */}
        <div className=' h-fit mt-9 mb-10 desktop:mb-32 flex justify-center '>
          <HomeProjects />
        </div>

        {/* Footer */}
        <div className='flex items-center justify-center w-5/6 m-auto mb-16 h-5/6 tablet:w-4/6 laptop:w-5/6 laptop:h-11/12 desktop:w-5/6 desktop:h-11/12 desktopXL:w-5/6 desktopXL:h-11/12'>
          <Footer />
        </div>
      </div>
    </div>
    </>
  );
}
